import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { FormValue, FormValueState } from '../entities/form-value.entity';

// stolen from angular source
function isEmptyInputValue(value: any): boolean {
    // we don't check for string here so it also works with arrays
    return value == null || value.length === 0;
}

export function FormValueGuard(obj: unknown): obj is FormValue<unknown> {
    return (
        obj instanceof FormValue ||
        (typeof obj === 'object' && obj !== null && obj.hasOwnProperty('state') && obj.hasOwnProperty('value'))
    );
}

export function FormValueRequired(
    control: AbstractControl,
    message: string = 'form.error.required-field'
): ValidationErrors | null {
    const controlValue: any = control.value;

    const errorObj: ValidationErrors = { required: true, message };

    if (controlValue instanceof Array) {
        if (!controlValue.every(value => FormValueGuard(value))) {
            return { required: true, wrongType: true };
        }
        const setValues: FormValue<unknown>[] = controlValue.filter(val => val.state === FormValueState.SET);

        if (setValues.length > 0) {
            return null;
        }
        const indeterminateValues: FormValue<unknown>[] = controlValue.filter(
            val => val.state === FormValueState.INDETERMINATE
        );
        if (indeterminateValues.length > 0) {
            return null;
        }
        return errorObj;
    }

    if (controlValue instanceof FormValue) {
        switch (controlValue.state) {
            case FormValueState.SET:
                return isEmptyInputValue(controlValue.value) ? errorObj : null;
            case FormValueState.UNSET:
                return errorObj;
            case FormValueState.INDETERMINATE:
                return null;
        }
    } else {
        return { required: true, wrongType: true };
    }

    return null;
}

export function isRequiredControl(control: AbstractControl): boolean {
    if (control.validator) {
        const validator: ValidationErrors | null = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            return true;
        }
    }
    return false;
}

export function FormGroupRequiredValidator(formGroup: FormGroup): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const allFormControlsValid = Object.keys(formGroup.controls).every(key => formGroup.controls[key].valid);

        if (!allFormControlsValid) {
            return { required: true, wrongType: true };
        }

        return null;
    };
}
